import React, { FC, useState } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import { Button } from 'transfix-ui/components/Button'
import { InputMultiSelect } from 'transfix-ui/components/InputMultiSelect'
import Box from 'transfix-ui/core/Box'
import { riskyAuditLevelOptions } from 'apps/marketplace/components/rfp/constants/strategyManager'
import { ILaneCriteria } from 'apps/marketplace/components/rfp/types/strategyManager'

interface IRiskyAuditLevelInputProps {
  value: string[]
  onSave: (changes: Partial<ILaneCriteria>) => void
  onCancel: () => void
}

export const RiskyAuditLevelInput: FC<IRiskyAuditLevelInputProps> = ({
  onCancel,
  onSave,
  value,
}) => {
  const [riskyAuditLevels, setRiskyAuditLevels] = useState<string[]>(value)

  const onRiskyAuditLevelsChange = (options: ISelectOption[]) => {
    const newValue = options.map(opt => opt.value)

    setRiskyAuditLevels(newValue)
  }

  const saveHandler = () => {
    onSave({
      liveAuditRiskLevel: riskyAuditLevels,
    })
  }

  return (
    <>
      <Box mb={1}>
        <InputMultiSelect
          label='Risky Audit Level'
          values={riskyAuditLevels}
          options={riskyAuditLevelOptions}
          onChange={onRiskyAuditLevelsChange}
          required
          large
        />
      </Box>
      <Box display='flex' justifyContent='flex-end'>
        <Box>
          <Button color='tertiary' onClick={onCancel}>
            Cancel
          </Button>
        </Box>
        <Box ml={1}>
          <Button color='primary' onClick={saveHandler}>
            Save
          </Button>
        </Box>
      </Box>
    </>
  )
}
